import {
  responseDataFormat,
  handleCatchErrors,
} from "../../middlewares/resolveRequests";
import {
  addNotificaton,
  delNotification,
  editNotificaton,
  getEditNotificationForm,
  getNotificationForm,
  resNotification,
  searchNotifications,
} from "../../services/sharek";

export const searchAllNotifications = async (
  pageNumber = 1,
  pageSize = 20,
  data = {},
  token
) => {
  let response;
  try {
    response = await searchNotifications(pageNumber, pageSize, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addNotificatonForm = async (data, token) => {
  let response;
  try {
    response = await addNotificaton(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getDataNotificationForm = async (token) => {
  let response;
  try {
    response = await getNotificationForm(token);
    // setVisible(true);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editNotificatonForm = async (data, token) => {
  let response;
  try {
    response = await editNotificaton(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getEditDataNotificationForm = async (notificationId, token) => {
  if (notificationId) {
    let response;
    try {
      response = await getEditNotificationForm(notificationId, token);
      // setVisible(true);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  }
};

export const deleteNotification = async (notificationId, token) => {
  let response;
  try {
    response = await delNotification(notificationId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const resendNotification = async (notificationId, token) => {
  let response;
  try {
    response = await resNotification(notificationId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
